// extracted by mini-css-extract-plugin
export default {"disabled":"refresh_match-module___disabled___f4b2beb1"};